import { z } from 'zod/v4';

export const UserTokensDTO = z.object({
  id: z.string(),
  is_active: z.boolean(),
  last_used_at: z.string(),
  name: z.string(),
  display_name: z.string(),
  description: z.string(),
});

export const CreatedUserTokenDTO = UserTokensDTO.extend({
  token: z.string(),
});

export const CreateUserTokenDTO = z.object({
  user_id: z.string(),
  name: z.string(),
  display_name: z.string(),
  description: z.string().optional(),
});

export type UserToken = z.infer<typeof UserTokensDTO>;
export type CreatedUserToken = z.infer<typeof CreatedUserTokenDTO>;
export type CreateUserToken = z.infer<typeof CreateUserTokenDTO>;